import { Skeleton, Stack } from "@mantine/core";
import React from "react";

type Props = {
  count: number;
};
function CardItemLoading({ count }: Props) {
  return (
    <Stack>
      {Array.from(Array(count), (_, i) => (
        <React.Fragment key={i}>
          <Skeleton h={70} />
        </React.Fragment>
      ))}
    </Stack>
  );
}

export default CardItemLoading;
